import {
  MainButton,
  MainLink,
  Subtitle,
  Title,
} from '../../styles/GlobalStyledComponents';
import {
  ClientInfo,
  ClientInfoWrapper,
  DotFlashingDiv,
  DotFlashingWrapper,
  IconImg,
  OperationSentImage,
} from './OperationShippingFinishedStyledComponents';
import ImageUrl from '../../assets/images/operation-shipping/shippingClient.svg';
import CheckIcon from '../../assets/images/operation-shipping/infoIcon.svg';
import PostMessageService, { BannerOutcome } from '../../services/PostMessage';
import ViewModeService from '../../services/ViewMode';
import { useContext, useEffect, useState } from 'react';
import hubInstance from '../../services/Websocket';
import { useWebsocket } from './../../contexts/WebsocketContext/websocket-context.hook';
import { CreditProposalResultContext } from '../../contexts/CreditProposalResultContext';

export const OperationShippingFinished = () => {
  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);
  const [infoList, setInfoList] = useState<string[] | any>([]);
  const [completed, setCompleted] = useState<boolean>(false);

  const { websocketTexts, createWebsocketTexts } = useWebsocket();
  const { creditProposalResult } = useContext(CreditProposalResultContext);
  const HIGH_AMOUNT_THRESHOLD = 4000;
  const dataList: string[] = [];

  const sendActivatedMessages = () => {
    if (!creditProposalResult) return;

    PostMessageService.BannerOutcome(BannerOutcome.ACTIVATED, {
      proposalId: creditProposalResult.credit_proposal_id,
      amount: creditProposalResult.loan_amount,
    });
    if (creditProposalResult.counter_offer_id) {
      PostMessageService.BannerOutcome(BannerOutcome.COUNTER_OFFER, {
        proposalId: creditProposalResult.credit_proposal_id,
        amount: creditProposalResult.loan_amount,
      });
    }
    if (
      creditProposalResult.loan_amount > HIGH_AMOUNT_THRESHOLD ||
      creditProposalResult.customer?.require_enrichment_personal_finances
    ) {
      PostMessageService.BannerOutcome(BannerOutcome.BELENDER_OR_HIGH_AMOUNT, {
        proposalId: creditProposalResult.credit_proposal_id,
        amount: creditProposalResult.loan_amount,
      });
    }
  };
  const sendDeniedMessages = () => {
    if (!creditProposalResult) return;
    PostMessageService.BannerOutcome(BannerOutcome.DENIED, {
      proposalId: creditProposalResult.credit_proposal_id,
    });
  };
  const handleReturn = () => {
    if (isApp && device === 'android') {
      window.location.href = 'peppermerchants://home';
    } else {
      PostMessageService.closeCEX();
    }
  };

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === 'APP' ? true : false);
    setDevice(ViewModeService.getDevice());
  }, [isApp, device]);

  const addTexts = (data: string) => {
    let messageReceived = false;
    dataList?.forEach((text: string) => {
      if (data === text) {
        messageReceived = true;
      }
    });
    !messageReceived && dataList.push(data);
    setInfoList([...dataList]);
  };

  const retrieveMessages = () => {
    const messagesLoaded = sessionStorage.getItem('PLS-Websocket');
    if (messagesLoaded) {
      const list = JSON.parse(messagesLoaded);
      list.forEach((message: any) => {
        dataList.push(message);
      });
      setInfoList(dataList);
    }
  };

  const startWebSocket = () => {
    if (creditProposalResult?.credit_proposal_id) {
      // console.log('start socket')
      const connect$ = hubInstance.connect();
      connect$.subscribe(
        (res) => {
          hubInstance.sendToken(creditProposalResult?.credit_proposal_id);
        },
        (err) => {
          console.error('HTTP Error', err);
        },
      );
    }
  };

  useEffect(() => {
    startWebSocket();
    retrieveMessages();
    hubInstance.paymentStartListener().subscribe(() => {
      addTexts('El cliente ha accedido al pago');
    });

    hubInstance.paymentEndListener().subscribe(() => {
      addTexts('Pago completado con éxito');
    });
    hubInstance.bankreaderStartListener().subscribe(() => {
      addTexts('Se ha iniciado el proceso de Banca Online');
    });
    hubInstance.bankreaderEndListener().subscribe(() => {
      addTexts('Proceso de Banca Online terminado con éxito');
    });
    hubInstance.ibanSelectionListener().subscribe(() => {
      addTexts('Se ha seleccionado una cuenta bancaria');
    });
    hubInstance.decisionResultListener().subscribe(() => {
      addTexts('El crédito ha sido aprobado');
    });
    hubInstance.signatureStartListener().subscribe(() => {
      addTexts('El cliente ha accedido a la firma');
    });
    hubInstance.signatureEndListener().subscribe(() => {
      addTexts('La firma se ha completado con éxito');
    });
    hubInstance.activationListener().subscribe(() => {
      addTexts('Activación completada');
      sendActivatedMessages();
      setCompleted(true);
    });
    hubInstance.ocrStartListener().subscribe(() => {
      addTexts('El cliente está adjuntando la documentación');
    });
    hubInstance.ocrEndListener().subscribe(() => {
      addTexts('Documentación adjuntada con éxito');
    });
    hubInstance.decisionRedListener().subscribe(() => {
      addTexts('El crédito ha sido denegado');
      sendDeniedMessages();
      setCompleted(true);
    });
    hubInstance.denegationWtdListener().subscribe(() => {
      addTexts('El crédito ha sido denegado');
      sendDeniedMessages();
      setCompleted(true);
    });
    hubInstance.denegationTudListener().subscribe(() => {
      addTexts('El cliente ha abandonado el proceso');
      setCompleted(true);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (infoList.length > 0) {
      createWebsocketTexts(infoList);
    } else if (websocketTexts) {
      setInfoList(websocketTexts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [infoList]);

  return (
    <>
      <Title>Evolución del proceso por parte del cliente:</Title>
      <ClientInfoWrapper>
        {infoList?.map((info: string) => {
          return (
            <ClientInfo key={info}>
              <IconImg src={CheckIcon} />
              <Subtitle>{info}</Subtitle>
            </ClientInfo>
          );
        })}
        {!completed && (
          <ClientInfo>
            <IconImg src={CheckIcon} />
            <DotFlashingWrapper>
              <DotFlashingDiv></DotFlashingDiv>
            </DotFlashingWrapper>
          </ClientInfo>
        )}
      </ClientInfoWrapper>
      <OperationSentImage src={ImageUrl}></OperationSentImage>
      {isApp && device === 'ios' ? (
        <MainLink href="peppermerchants://home">Terminar</MainLink>
      ) : (
        <MainButton onClick={handleReturn}>Terminar</MainButton>
      )}
    </>
  );
};
